import(/* webpackMode: "eager" */ "/data/src/app/basket/page.jsx")